import { render, staticRenderFns } from "./AuctionPolicyPage.vue?vue&type=template&id=72ac5f3f&"
import script from "./AuctionPolicyPage.vue?vue&type=script&lang=js&"
export * from "./AuctionPolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports